module.exports = __webpack_public_path__ + "images/browser-logo-qq-911e4596017d942b5f427cca088f9268.jpg";